import { UserProfile } from 'src/app/core/models/user';
import { Component, OnInit, Inject } from '@angular/core';
import { Jurisdiction } from './../../../core/models/user/jurisdiction';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SaveData } from 'src/app/core/models/user-management/save-data';
import { SessionService } from 'src/app/core/services/auth/session.service';
import { UserJurisdiction } from 'src/app/core/models/user/user-jurisdiction';
import { CommonService } from './../../../core/services/common/common.service';
import { JurisdictionModel } from 'src/app/core/models/user/jurisdiction-model';
import { UserRegulatorDto } from './../../../core/models/user/user-regulator-dto';
import { UserManagementService } from 'src/app/core/services/user-management/user-management.service';
import { ToastViewModel } from 'src/app/core/models/view-model';

@Component({
  selector: 'app-user-regulator-dialog',
  templateUrl: './user-regulator-dialog.component.html',
  styleUrls: ['./user-regulator-dialog.component.scss']
})
export class UserRegulatorDialogComponent implements OnInit {

  searchText = '';
  isJuriSelectAll = false;
  selectedJuriArray: Array<number>;
  jurisdictions: Array<Jurisdiction>;
  jurisdictionList: Array<Jurisdiction>;
  userJurisdiction: Array<UserJurisdiction>;
  saveDataModel: SaveData;
  userAccessToken!: UserProfile;
  isDisabled = false;
  disabledText = '';
  isLoader = false;
  jurisdictionObj: Jurisdiction;
  toastModel: ToastViewModel;
  isToastShow = false;
  
  constructor(
    private sessionService: SessionService, private userService: UserManagementService,
    public commonService: CommonService,
    public dialogRef: MatDialogRef<UserRegulatorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public itemsDto: UserRegulatorDto) {
    this.selectedJuriArray = [];
    this.jurisdictions = [];
    this.jurisdictionList = [];
    this.userJurisdiction = [];
    this.saveDataModel = new SaveData();
    this.jurisdictionObj = new Jurisdiction();
    this.toastModel = new ToastViewModel();
  }

  ngOnInit(): void {
    this.getUserProfile();
    this.fetchJurisdictions();
  }

  getUserProfile(): void {
    this.sessionService.getLoginUserInfo().subscribe((result: UserProfile) => {
      this.userAccessToken = result;
    });
  }

  // Jurisdiction
  fetchJurisdictions(): void {
    this.userService.getJurisdictions(this.itemsDto.userId).subscribe((data: JurisdictionModel) => {
      if (data.userJurisdictions) {
        this.userJurisdiction = data.userJurisdictions;
        this.userJurisdiction.forEach(element => {
          this.selectedJuriArray.push(element.jurisdictionId);
        });
      }
      this.jurisdictions = data.jurisdictions;
      this.jurisdictionList = data.jurisdictions;
      this.isJuriSelectAll = (this.jurisdictionList && this.jurisdictionList.length) ===
        (this.userJurisdiction && this.userJurisdiction.length) ? true : false;
    });
  }

  checkUserJurisdiction(jurisId: number): boolean {
    if (this.userJurisdiction.length === 0) {
      return false;
    } else {
      const result = this.userJurisdiction.find(a => a.jurisdictionId === jurisId);
      return result ? true : false;
    }
  }

  updateJurisdiction(id: number, event: any): void {
    if (event.currentTarget.checked && !this.selectedJuriArray.find(a => a === id)) {
      this.selectedJuriArray.push(id);
    } else {
      const index = this.selectedJuriArray.indexOf(id);
      if (index > -1) {
        this.selectedJuriArray.splice(index, 1);
      }
    }
  }

  selectAllJurisdiction(event: any): void {
    if (event.currentTarget.checked) {
      this.selectedJuriArray = [];
      this.jurisdictionList.forEach(element => {
        this.selectedJuriArray.push(element.id);
        const userJurisdiction = new UserJurisdiction();
        userJurisdiction.userId = this.userAccessToken ? this.userAccessToken.userId : 0;
        userJurisdiction.jurisdictionId = element.id;
        this.userJurisdiction.push(userJurisdiction);
      });
    } else {
      this.selectedJuriArray = [];
      this.userJurisdiction = [];
    }
    this.isJuriSelectAll = (this.jurisdictionList && this.jurisdictionList.length) ===
      (this.userJurisdiction && this.userJurisdiction.length) ? true : false;
  }

  onEnterKeySearchJurisdiction(event: any): void {
    if (event.keyCode === 13) {
      this.searchJurisdiction();
    }
    if (event.keyCode === 8 && !this.searchText) {
      this.jurisdictionList = this.jurisdictions;
    }
  }

  searchJurisdiction(): void {
    if (this.searchText) {
      this.jurisdictionList = this.jurisdictionList.filter(a => a.title.toLowerCase()
        .includes(this.searchText.toLowerCase()));
    } else {
      this.jurisdictionList = this.jurisdictions;
    }
  }

  saveJurisdiction(): void {
    if(this.selectedJuriArray.length>0){
      this.saveDataModel.filter = 'Jurisdiction';
      this.saveDataModel.itemArray = this.selectedJuriArray;
      this.dialogRef.close(this.saveDataModel);
    }
    else{
      this.warningAlert("Please select at least one division");
    }
    
  }

  onKeyUp(event: any): void {
    if (event.keyCode === 13) {
      this.addJurisdiction();
    }
    if (event.keyCode === 8 && !this.jurisdictionObj.title) {
      this.disabledText = 'Please enter jurisdiction first.';
      this.isDisabled = true;
      this.hideNotification();
    } else {
      this.disabledText = '';
      this.isDisabled = false;
    }
  }

  addJurisdiction(): void {
    if (!this.jurisdictionObj.title) {
      this.disabledText = 'Please enter jurisdiction first.';
      this.isDisabled = true;
      this.hideNotification();
    } else if (this.jurisdictionList.some(a => a.title.toUpperCase() === this.jurisdictionObj.title.toUpperCase())) {
      this.disabledText = 'This jurisdiction already exist.';
      this.isDisabled = true;
      this.hideNotification();
    } else {
      this.isLoader = true;
      this.userService.addJurisdictions(this.jurisdictionObj).subscribe((data: any) => {
        this.fetchJurisdictions();
        this.isLoader = false;
        this.jurisdictionObj = new Jurisdiction();
        this.disabledText = '';
      });
    }
  }

  hideNotification(): void {
    setTimeout(() => {
      this.disabledText = '';
      this.isDisabled = false;
    }, 3000);
  }
  warningAlert(msg: string): void {
    this.toastModel.Title = 'Warning';
    this.toastModel.Type = 'warning';
    this.toastModel.Message = msg;
    this.isToastShow = true;
    setTimeout(() => {
      this.isToastShow = false;
    }, 5000);
  }
}
